




































import { Vue, Component, Prop } from "vue-property-decorator";

import { InputTypes, SimpleInput as Simple, TextArea } from "@netex/inputs";

import PageTitle from "@/components/common/PageTitle.vue";

enum DataProps {
  phone = "phone",
  email = "email",
  message = "message",
}

interface IValidationField {
  value: string | number;
  errorMessage: string;
}

interface InputSchema {
  type: string;
  name: string;
  required?: boolean;
  placeholder?: string;
  inputType?: string;
  prefix?: string;
  mask?: IValidationField;
  regex?: IValidationField;
  min?: IValidationField;
  max?: IValidationField;
}

interface InputElement extends Element {
  checkForErrors: () => boolean;
  checkForValid: () => void;
}

interface Payload {
  [DataProps.phone]: number | null;
  [DataProps.email]: string;
  [DataProps.message]: string;
}

@Component({
  components: {
    Simple,
    PageTitle,
  },
})
export default class DealerForm extends Vue {
  @Prop({ type: Function, default: () => null })
  readonly sendData!: (data: Payload) => Promise<any>;

  error: boolean = false;
  success: string = "";
  inputFields: InputSchema[] = [
    {
      type: "input-simple",
      name: "phone",
      required: true,
      placeholder: "Номер телефона",
      mask: {
        value: "+7 (###) ###-##-##",
        errorMessage: "Некорректный телефон",
      },
      prefix: "+7 (",
    },
    {
      type: "input-simple",
      name: "email",
      required: true,
      placeholder: "Электронный адрес",
      regex: {
        value:
          '^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$',
        errorMessage: "Введите валидный адрес",
      },
    },
    {
      type: "input-text-field",
      name: "message",
      required: true,
      placeholder: "Ваше сообщение",
    },
  ];

  inputData: Payload = {
    [DataProps.phone]: null,
    [DataProps.email]: "",
    [DataProps.message]: "",
  };

  content = {
    message: "Стать партнером",
  };

  redirect(link: string) {
    this.$router.replace({ path: link });
  }

  getInput(type: InputTypes) {
    switch (type) {
      case InputTypes.TEXT:
        return TextArea;
      default:
        return Simple;
    }
  }

  async submit() {
    if (!this.errorCheck()) {
      try {
        const res = await this.sendData(this.inputData);
        this.success = res.data.message;
      } catch (err) {
        this.error = true;
        console.warn(err);
      }
    }
  }

  errorCheck() {
    const errors: boolean[] = [];
    const refs = Object.keys(this.$refs);
    refs.forEach(ref => {
      (this.$refs[ref] as InputElement[])[0].checkForValid();
      const error = (this.$refs[ref] as InputElement[])[0].checkForErrors();
      if (error) errors.push(error);
    });
    return errors.length;
  }

  setValue(str: DataProps, val: string) {
    const data = Object.assign({}, this.inputData);
    if (str === DataProps.phone) {
      data[str] = parseInt(val, 10);
    } else {
      data[str] = val;
    }
    this.inputData = data;
  }
}
